import { Button } from "@mui/material";

const WCDButton = ({ text, startIcon, onClick }) => {
  return (
    <Button
      fullWidth
      color="yellow"
      variant="contained"
      sx={{
        borderRadius: "25px",
        marginTop: "2px",
        fontWeight: 600,
        minHeight: "36px",
      }}
      startIcon={startIcon}
      onClick={onClick}
    >
      {text}
    </Button>
  );
};

export default WCDButton;
